export default __webpack_public_path__ + "static/media/review-10.bfa9ee4f.png";